import jQuery from 'jquery';
let $ = jQuery;

var HSN = window.HSN || {};

HSN.DataLayer = (function ($) {
    "use strict";

    window.console = window.console || {};

    var wellKnownEventNames = {
        METRIC: "metric",
        PERSONALIZATION: "personalization",
        VIRTUALPAGEVIEW: "virtualPageView",
        COMPASS: "compass_event",
        HSNEVENT: "hsn_event"
    }

    var wellKnownEventCategories = {
        PRODUCT: "product"
    };

    var wellKnownActions = {
        ADDTOBAG: "addtobag",
        SAVEFORLATER: "saveforlater",
        CHECKOUT: "checkout",
        ORDERREVIEW: "orderreview",
        PURCHASE: "purchase",
        TOGGLEFAVORITE: "togglefavorite",
        SEARCH: "search",
        SUGGESTSEARCH: "suggestsearch",
        ADDTOFAVORITES: "addtofavorites",
        REMOVEFROMFAVORITES: "removefromfavorites"
    };

    function publicGetValueForKey(key) {
        return Object.assign.apply(Object, window.dataLayer)[key];
    }

    function publicSendData(udo) {
        HSN.OnGtmLoad(function () {
            window.dataLayer.push(udo);
        });
    }

    function publicSendEvent(udo, eventName, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        if (!(udo && udo.metrics_event_category || metricsEventCategoryOverride) || !(udo && udo.metrics_event_action || metricsEventActionOverride)) {
            return;
        }

        var data = {
            "event": eventName,
            "metrics_event_category": metricsEventCategoryOverride,
            "metrics_event_action": metricsEventActionOverride,
            "metrics_event_label": metricsEventLabelOverride,
            "metrics_event_value": metricsEventValueOverride,
            "metrics_event_is_non_interaction": metricsEventIsNonInteractionOverride
        };

        var defaultUdo = getObjectWithKeysFromArray(["metrics_event_label", "metrics_event_value", "metrics_event_is_non_interaction"]);
        var compositeUdo = $.extend(defaultUdo, udo, data);

        publicSendData(compositeUdo);
    }

    function publicSendCompassEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        publicSendEvent(udo, wellKnownEventNames.COMPASS, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride);
    }

    function publicSendPersonalizationEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        publicSendEvent(udo, wellKnownEventNames.PERSONALIZATION, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride);
    }

    function publicSendMetricEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride) {
        publicSendEvent(udo, wellKnownEventNames.METRIC, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride, metricsEventIsNonInteractionOverride);
    }

    function publicSendHsnEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride) {
        publicSendEvent(udo, wellKnownEventNames.HSNEVENT, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, metricsEventValueOverride);
    }

    function publicAddToBag(udo, skuOverride, qtyOverride) {
        if (!(udo && udo.product_sku || skuOverride) || !(udo && udo.product_quantity || qtyOverride)) {
            return;
        }

        publicSendPersonalizationEvent(udo, wellKnownEventCategories.PRODUCT, wellKnownActions.ADDTOBAG);
    }

    function publicCheckout(udo) {
        publicSendPersonalizationEvent(udo, wellKnownEventCategories.PRODUCT, wellKnownActions.CHECKOUT);
    }

    function publicSaveForLater(udo, basketId) {
        if (!basketId) {
            return;
        }

        publicSendPersonalizationEvent(udo, wellKnownEventCategories.PRODUCT, wellKnownActions.SAVEFORLATER, basketId);
    }

    function publicToggleFavorite(udo, cmPrefix, objectType, objectId, isFavorite) {
        if (!cmPrefix) {
            return;
        }

        var category = "RE:" + cmPrefix.toLowerCase();
        var action = isFavorite ? wellKnownActions.ADDTOFAVORITES : wellKnownActions.REMOVEFROMFAVORITES;
        var label = "na";
        var value = null;

        publicSendPersonalizationEvent(udo, category, action, label, value);
    }

    function publicSendVirtualPageview(udo, pageTypeOverride, pageNameOverride, pageNameSetter) {
        var virtualPageviewUdo = udo || {};
        var virtualPageType = pageTypeOverride || virtualPageviewUdo.virtual_page_type;
        var virtualPageName = pageNameOverride || virtualPageviewUdo.virtual_page_name;
        var pageNameSet = pageNameSetter || virtualPageviewUdo.page_name;

        if (!virtualPageType) {
            return;
        }

        var data = {
            "event": wellKnownEventNames.VIRTUALPAGEVIEW,
            "virtual_page_type": "virtual-" + virtualPageType,
            "virtual_page_name": virtualPageName,
            "page_name": pageNameSet
        };

        var defaultUdo = getObjectWithKeysFromArray(["virtual_page_type", "virtual_page_name"]);
        var compositeUdo = $.extend(defaultUdo, udo, data);

        publicSendData(compositeUdo);
    }

    function getObjectWithKeysFromArray(keys) {
        return keys.reduce(function (result, currentItem) {
            result[currentItem] = undefined;
            return result;
        }, {});
    }

    function publicPageCategorization(udo, pageType, categories, brandName) {
        var data = {
            "page_type": pageType || undefined,
            "categories": categories || undefined,
            "product_brand_name": brandName || undefined
        };
        var defaultUdo = getObjectWithKeysFromArray(["page_type", "categories", "product_brand_name"]);
        var compositeUdo = $.extend(defaultUdo, udo, data);

        if ($.inArray(compositeUdo.page_type, ["Home Page", "Storefront", "Department", "Category", "SubCategory", "Grid", "Brand", "Feature", "Product", "todspc", "Arcade", "Account"]) < 0) {
            return;
        }

        var pageCategoryStorefront = "None";
        var pageCategoryDepartment = "None";
        var pageCategoryCategory = "None";
        var pageCategorySubCategory = "None";
        var pageCategoryBrand = "None";

        if (compositeUdo.categories && compositeUdo.categories.length > 0 && compositeUdo.categories[0].length > 0) {
            var catCount = compositeUdo.categories[0].length;

            switch (catCount) {
                case 4:
                    pageCategorySubCategory = compositeUdo.categories[0][3].Name;
                case 3:
                    pageCategoryCategory = compositeUdo.categories[0][2].Name;
                case 2:
                    pageCategoryDepartment = compositeUdo.categories[0][1].Name;
                default:
                    pageCategoryStorefront = compositeUdo.categories[0][0].Name;
            }
        }

        if (compositeUdo.product_brand_name && compositeUdo.product_brand_name !== "") {
            pageCategoryBrand = compositeUdo.product_brand_name;
        }

        var metricsEventCategoryOverride = "PT:" + compositeUdo.page_type + "|SF:" + pageCategoryStorefront;
        var metricsEventActionOverride = "D:" + pageCategoryDepartment + "|C:" + pageCategoryCategory;
        var metricsEventLabelOverride = "SC:" + pageCategorySubCategory + "|B:" + pageCategoryBrand;

        publicSendMetricEvent(udo, metricsEventCategoryOverride, metricsEventActionOverride, metricsEventLabelOverride, undefined, true);
    }

    function publicRealEstate(udo, cmRealEstateTag) {
        var realEstateFields = (cmRealEstateTag || "").split("-_-");
        var realEstateUdo = udo || {};

        var realEstateCategory = realEstateFields[0] || realEstateUdo.metrics_event_category;
        var realEstateAction = realEstateFields[1] || realEstateUdo.metrics_event_action;
        var realEstateLabel = realEstateFields[2] || realEstateUdo.metrics_event_label;

        if (realEstateCategory !== null && realEstateCategory !== undefined) {
            realEstateCategory = "RE:" + realEstateCategory.toLowerCase();
        }
        if (realEstateAction !== null && realEstateAction !== undefined) {
            realEstateAction = realEstateAction.toLowerCase();
        }
        if (realEstateLabel !== null && realEstateLabel !== undefined) {
            realEstateLabel = realEstateLabel.toLowerCase();
        }

        publicSendMetricEvent(udo, realEstateCategory, realEstateAction, realEstateLabel);
    }

    function publicElementInteraction(udo, element, action) {
        var elementUdo = udo || {};
        var elementCategory = "EL:" + (element || elementUdo.metrics_event_category);
        var elementAction = action || elementUdo.metrics_event_action;

        publicSendMetricEvent(udo, elementCategory, elementAction);
    }
    
    return {
        sendData: publicSendData,
        wellKnownEventCategories: wellKnownEventCategories,
        wellKnownActions: wellKnownActions,
        helpers: {
            event: publicSendEvent,
            metricEvent: publicSendMetricEvent,
            hsnEvent: publicSendHsnEvent,
            personalizationEvent: publicSendPersonalizationEvent,
            compassEvent: publicSendCompassEvent,
            virtualPageview: publicSendVirtualPageview,
            addToBag: publicAddToBag,
            saveForLater: publicSaveForLater,
            favorite: publicToggleFavorite,
            pageCategorization: publicPageCategorization,
            realEstate: publicRealEstate,
            elementInteraction: publicElementInteraction,
            checkout: publicCheckout
        },
        getValueForKey: publicGetValueForKey
    };
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/HSN/DataLayer.js